/**
 * TransactionCategoryService
 * Service for TransactionCategory entity operations
 * Route: api/transaction-category
 * Controller: TransactionCategoryController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * TransactionCategoryService
 * Handles transaction category CRUD operations
 * Maps to /api/transaction-category endpoint
 */
export class TransactionCategoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TransactionCategoryService.DEFAULT_SERVICE_PATH,
            basePath: TransactionCategoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate transaction category cache
     * POST /api/transaction-category/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate transaction category cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
TransactionCategoryService.DEFAULT_SERVICE_PATH = 'payments';
TransactionCategoryService.BASE_PATH = 'api/transaction-category';
//# sourceMappingURL=TransactionCategoryService.js.map